export const SHOW_DOCUMENT_FORM = 'SHOW_DOCUMENT_FORM';
export const HIDE_DOCUMENT_FORM = 'HIDE_DOCUMENT_FORM';
export const SHOW_DOCUMENT_PREVIEW = 'SHOW_DOCUMENT_PREVIEW';
export const HIDE_DOCUMENT_PREVIEW = 'HIDE_DOCUMENT_PREVIEW';